<template>
  <g
    id="Main_body-3"
    v-on:click="changeSeverity('rearMainBody')"
    :class="severityClass"
  >
    <g>
      <g>
        <polygon
          class="cls-437"
          points="70.69 260.55 76.76 257.74 76.77 253.15 76.77 252.44 76.77 248.91 76.16 248.91 70.71 248.91 70.7 252.43 70.7 253.13 70.69 260.55"
        />
        <path
          class="cls-436"
          d="M69.89,230.29s0-.06,.01-.09c0-.03-.01-.05-.01-.08,0-.64,1.72-1.24,3.86-1.24s3.88,.52,3.88,1.16c0,.02,0,.04-.01,.06,.02,.06,.03,.13,.03,.19l-.03,21.84c0,.16-.19,.29-.42,.29h-.42s-.62,0-.62,0h-5.45s-.42,0-.42,0c-.23,0-.42-.13-.42-.29l.03-21.84Z"
        />
        <path
          class="cls-436"
          d="M69.87,252.14c0-.64,1.73-1.15,3.87-1.15s3.87,.52,3.87,1.15-1.73,1.15-3.87,1.15-3.87-.52-3.87-1.15Z"
        />
        <path
          class="cls-436"
          d="M73.69,251.37c1.13,0,2.14,.15,2.84,.38,.13,.04,.22,.17,.22,.31v30h-6.03v-30.01c0-.14,.08-.26,.21-.31,.69-.24,1.65-.37,2.76-.37Z"
        />
        <path
          class="cls-436"
          d="M69.85,292.46v.39s0,1.31,0,1.31c0,.3,.26,.53,.58,.53h5.71s.59,0,.59,0h.3c.32,0,.58-.23,.57-.52v-12.86s.01-27.86,.01-27.86c0-.01,0-.03,0-.04,0-.01,0-.03,0-.04,0-.64-1.73-1.15-3.87-1.15s-3.88,.52-3.88,1.15c0,.01,0,.02,0,.03,0,.01,0,.03,0,.04v27.86s-.02,6.77-.02,6.77v1.96s0,2.42,0,2.42Z"
        />
        <path
          class="cls-436"
          d="M69.83,294.37c0-.64,1.73-1.15,3.87-1.15s3.87,.52,3.87,1.15-1.73,1.15-3.87,1.15-3.87-.52-3.87-1.15Z"
        />
        <path
          class="cls-436"
          d="M73.7,293.81c1.13,0,2.14,.15,2.84,.38,.13,.04,.22,.17,.22,.31v1.17s0,24.7,0,24.7c0,1.11-.14,2.21-.41,3.28l-.66,2.63h-3.89l-.66-2.63c-.27-1.07-.41-2.17-.41-3.28v-25.87c0-.14,.08-.26,.21-.31,.69-.24,1.65-.37,2.76-.37Z"
        />
      </g>
      <rect
        class="cls-436"
        x="71.33"
        y="322.88"
        width="4.83"
        height="5.42"
        rx="1.23"
        ry="1.23"
        transform="translate(147.49 651.19) rotate(180)"
      />
    </g>
    <g>
      <g>
        <polygon
          class="cls-437"
          points="45.69 260.55 51.76 257.74 51.77 253.15 51.77 252.44 51.78 248.91 51.16 248.91 45.71 248.91 45.7 252.43 45.7 253.13 45.69 260.55"
        />
        <path
          class="cls-436"
          d="M44.89,230.29s0-.06,.01-.09c0-.03-.01-.05-.01-.08,0-.64,1.72-1.24,3.86-1.24s3.88,.52,3.88,1.16c0,.02,0,.04-.01,.06,.02,.06,.03,.13,.03,.19l-.03,21.84c0,.16-.19,.29-.42,.29h-.42s-.62,0-.62,0h-5.45s-.42,0-.42,0c-.23,0-.42-.13-.42-.29l.03-21.84Z"
        />
        <path
          class="cls-436"
          d="M44.87,252.14c0-.64,1.73-1.15,3.87-1.15s3.87,.52,3.87,1.15-1.73,1.15-3.87,1.15-3.87-.52-3.87-1.15Z"
        />
        <path
          class="cls-436"
          d="M48.69,251.37c1.13,0,2.14,.15,2.84,.38,.13,.04,.22,.17,.22,.31v30h-6.03v-30.01c0-.14,.08-.26,.21-.31,.69-.24,1.65-.37,2.76-.37Z"
        />
        <path
          class="cls-436"
          d="M44.85,292.46v.39s0,1.31,0,1.31c0,.3,.26,.53,.58,.53h5.71s.59,0,.59,0h.3c.32,0,.58-.23,.57-.52v-12.86s.01-27.86,.01-27.86c0-.01,0-.03,0-.04,0-.01,0-.03,0-.04,0-.64-1.73-1.15-3.87-1.15s-3.88,.52-3.88,1.15c0,.01,0,.02,0,.03,0,.01,0,.03,0,.04v27.86s-.02,6.77-.02,6.77v1.96s0,2.42,0,2.42Z"
        />
        <path
          class="cls-436"
          d="M44.83,294.37c0-.64,1.73-1.15,3.87-1.15s3.87,.52,3.87,1.15-1.73,1.15-3.87,1.15-3.87-.52-3.87-1.15Z"
        />
        <path
          class="cls-436"
          d="M48.7,293.81c1.13,0,2.14,.15,2.84,.38,.13,.04,.22,.17,.22,.31v1.17s0,24.7,0,24.7c0,1.11-.14,2.21-.41,3.28l-.66,2.63h-3.89l-.66-2.63c-.27-1.07-.41-2.17-.41-3.28v-25.87c0-.14,.08-.26,.21-.31,.69-.24,1.65-.37,2.76-.37Z"
        />
      </g>
      <rect
        class="cls-436"
        x="46.33"
        y="322.88"
        width="4.83"
        height="5.42"
        rx="1.23"
        ry="1.23"
        transform="translate(97.49 651.19) rotate(180)"
      />
    </g>
    <path
      class="cls-611"
      d="M76.34,259.93h0v29.15h0c-3.19,0-5.77-2.59-5.77-5.77v-17.6c0-3.19,2.59-5.77,5.77-5.77Z"
      transform="translate(146.91 549.01) rotate(-180)"
    />
    <path
      class="cls-471"
      d="M51.27,293.23h5.1v29.15h-5.1c-3.33,0-6.03-2.7-6.03-6.03v-17.09c0-3.33,2.7-6.03,6.03-6.03Z"
    />
    <path
      class="cls-471"
      d="M71.45,293.23h5.1v29.15h-5.1c-3.33,0-6.03-2.7-6.03-6.03v-17.09c0-3.33,2.7-6.03,6.03-6.03Z"
      transform="translate(141.96 615.61) rotate(180)"
    />
    <path
      class="cls-904"
      d="M49.34,294.91h.56v21.83h-.56c-2.88,0-5.22-2.34-5.22-5.22v-11.39c0-2.88,2.34-5.22,5.22-5.22Z"
    />
    <g>
      <g>
        <path
          class="cls-204"
          d="M44.02,328.62c-1.92,0-3.71-1.06-4.62-2.79l-6.85-13.06,1.42-.75,6.85,13.06c.71,1.35,2.2,2.11,3.71,1.9l14.55-2.08,.23,1.59-14.55,2.08c-.25,.04-.49,.05-.74,.05Z"
        />
        <path
          class="cls-584"
          d="M32.63,312.8l.53-.28,.83-.33,6.6,12.57s.2,.37,.21,.39c.72,1.33,2.18,2.08,3.68,1.89,.02,0,.56-.08,.58-.08l13.87-1.98,.23,.85,.09,.6-14.49,2.07c-.24,.03-.49,.05-.73,.05-1.9,0-3.67-1.05-4.57-2.76l-6.82-13Z"
        />
        <path
          class="cls-431"
          d="M32.71,312.82l.52-.27,.78-.19,6.55,12.47s.19,.36,.21,.38c.72,1.31,2.16,2.05,3.65,1.89,.04,0,.54-.07,.58-.07l13.78-1.97,.31,.73,.08,.6-14.43,2.06c-.24,.03-.48,.05-.72,.05-1.88,0-3.63-1.04-4.51-2.73l-6.8-12.95Z"
        />
        <path
          class="cls-496"
          d="M32.79,312.85l.51-.27,.73-.05,6.5,12.38s.18,.34,.21,.38c.73,1.29,2.15,2.03,3.63,1.88,.06,0,.52-.06,.58-.07l13.68-1.96,.4,.61,.08,.59-14.37,2.06c-.24,.03-.47,.05-.71,.05-1.86,0-3.59-1.03-4.46-2.7l-6.77-12.9Z"
        />
        <path
          class="cls-629"
          d="M32.87,312.87l.51-.27,.67,.09,6.45,12.28c.03,.06,.17,.32,.21,.38,.73,1.26,2.13,2,3.6,1.88,.09,0,.49-.05,.58-.06l13.59-1.94,.48,.48,.08,.58-14.31,2.05c-.23,.03-.47,.05-.7,.05-1.84,0-3.54-1.02-4.41-2.66l-6.74-12.85Z"
        />
        <path
          class="cls-503"
          d="M32.95,312.9l.5-.26,.62,.23,6.4,12.18c.04,.07,.17,.31,.21,.37,.74,1.24,2.12,1.97,3.57,1.88,.11,0,.47-.04,.58-.06l13.49-1.93,.57,.36,.08,.57-14.26,2.04c-.23,.03-.46,.05-.69,.05-1.82,0-3.5-1.01-4.36-2.63l-6.71-12.79Z"
        />
        <path
          class="cls-595"
          d="M33.03,312.92l.49-.26,.57,.37,6.34,12.09c.04,.08,.16,.29,.21,.37,.75,1.22,2.1,1.94,3.54,1.87,.13,0,.45-.04,.58-.05l13.4-1.92,.65,.24,.08,.56-14.2,2.03c-.23,.03-.46,.05-.69,.05-1.8,0-3.46-.99-4.3-2.6l-6.69-12.74Z"
        />
        <path
          class="cls-643"
          d="M33.11,312.95l.49-.26,.52,.51,6.29,11.99c.05,.1,.15,.28,.21,.37,.75,1.2,2.09,1.91,3.52,1.87,.15,0,.43-.03,.58-.05l13.3-1.9,.74,.12,.08,.55-14.14,2.02c-.22,.03-.45,.05-.68,.05-1.78,0-3.42-.98-4.25-2.57l-6.66-12.69Z"
        />
        <path
          class="cls-22"
          d="M33.19,312.97l.48-.25,.46,.64,6.24,11.9c.06,.11,.14,.26,.21,.36,.76,1.18,2.07,1.89,3.49,1.86,.17,0,.41-.02,.58-.05l13.2-1.89h.83s.08,.53,.08,.53l-14.08,2.01c-.22,.03-.45,.05-.67,.05-1.77,0-3.38-.97-4.2-2.54l-6.63-12.63Z"
        />
        <path
          class="cls-485"
          d="M44.02,328.09c-1.75,0-3.34-.96-4.15-2.51l-6.6-12.58,.47-.25,6.6,12.58c.72,1.37,2.13,2.22,3.67,2.22,.19,0,.39-.01,.58-.04l14.02-2,.08,.53-14.02,2c-.22,.03-.44,.05-.66,.05Z"
        />
      </g>
      <rect
        class="cls-419"
        x="27.32"
        y="310.94"
        width="12.95"
        height="2.93"
        rx="1.02"
        ry="1.02"
      />
    </g>
    <g>
      <g>
        <path
          class="cls-204"
          d="M77.76,328.62c1.92,0,3.71-1.06,4.62-2.79l6.85-13.06-1.42-.75-6.85,13.06c-.71,1.35-2.2,2.11-3.71,1.9l-14.55-2.08-.23,1.59,14.55,2.08c.25,.04,.49,.05,.74,.05Z"
        />
        <path
          class="cls-584"
          d="M89.15,312.8l-.53-.28-.83-.33-6.6,12.57s-.2,.37-.21,.39c-.72,1.33-2.18,2.08-3.68,1.89-.02,0-.56-.08-.58-.08l-13.87-1.98-.23,.85-.09,.6,14.49,2.07c.24,.03,.49,.05,.73,.05,1.9,0,3.67-1.05,4.57-2.76l6.82-13Z"
        />
        <path
          class="cls-431"
          d="M89.07,312.82l-.52-.27-.78-.19-6.55,12.47s-.19,.36-.21,.38c-.72,1.31-2.16,2.05-3.65,1.89-.04,0-.54-.07-.58-.07l-13.78-1.97-.31,.73-.08,.6,14.43,2.06c.24,.03,.48,.05,.72,.05,1.88,0,3.63-1.04,4.51-2.73l6.8-12.95Z"
        />
        <path
          class="cls-496"
          d="M88.99,312.85l-.51-.27-.73-.05-6.5,12.38s-.18,.34-.21,.38c-.73,1.29-2.15,2.03-3.63,1.88-.06,0-.52-.06-.58-.07l-13.68-1.96-.4,.61-.08,.59,14.37,2.06c.24,.03,.47,.05,.71,.05,1.86,0,3.59-1.03,4.46-2.7l6.77-12.9Z"
        />
        <path
          class="cls-629"
          d="M88.91,312.87l-.51-.27-.67,.09-6.45,12.28c-.03,.06-.17,.32-.21,.38-.73,1.26-2.13,2-3.6,1.88-.09,0-.49-.05-.58-.06l-13.59-1.94-.48,.48-.08,.58,14.31,2.05c.23,.03,.47,.05,.7,.05,1.84,0,3.54-1.02,4.41-2.66l6.74-12.85Z"
        />
        <path
          class="cls-503"
          d="M88.83,312.9l-.5-.26-.62,.23-6.4,12.18c-.04,.07-.17,.31-.21,.37-.74,1.24-2.12,1.97-3.57,1.88-.11,0-.47-.04-.58-.06l-13.49-1.93-.57,.36-.08,.57,14.26,2.04c.23,.03,.46,.05,.69,.05,1.82,0,3.5-1.01,4.36-2.63l6.71-12.79Z"
        />
        <path
          class="cls-595"
          d="M88.75,312.92l-.49-.26-.57,.37-6.34,12.09c-.04,.08-.16,.29-.21,.37-.75,1.22-2.1,1.94-3.54,1.87-.13,0-.45-.04-.58-.05l-13.4-1.92-.65,.24-.08,.56,14.2,2.03c.23,.03,.46,.05,.69,.05,1.8,0,3.46-.99,4.3-2.6l6.69-12.74Z"
        />
        <path
          class="cls-643"
          d="M88.67,312.95l-.49-.26-.52,.51-6.29,11.99c-.05,.1-.15,.28-.21,.37-.75,1.2-2.09,1.91-3.52,1.87-.15,0-.43-.03-.58-.05l-13.3-1.9-.74,.12-.08,.55,14.14,2.02c.22,.03,.45,.05,.68,.05,1.78,0,3.42-.98,4.25-2.57l6.66-12.69Z"
        />
        <path
          class="cls-22"
          d="M88.59,312.97l-.48-.25-.46,.64-6.24,11.9c-.06,.11-.14,.26-.21,.36-.76,1.18-2.07,1.89-3.49,1.86-.17,0-.41-.02-.58-.05l-13.2-1.89h-.83s-.08,.53-.08,.53l14.08,2.01c.22,.03,.45,.05,.67,.05,1.77,0,3.38-.97,4.2-2.54l6.63-12.63Z"
        />
        <path
          class="cls-485"
          d="M77.76,328.09c1.75,0,3.34-.96,4.15-2.51l6.6-12.58-.47-.25-6.6,12.58c-.72,1.37-2.13,2.22-3.67,2.22-.19,0-.39-.01-.58-.04l-14.02-2-.08,.53,14.02,2c.22,.03,.44,.05,.66,.05Z"
        />
      </g>
      <rect
        class="cls-419"
        x="81.63"
        y="310.94"
        width="12.95"
        height="2.93"
        rx="1.02"
        ry="1.02"
        transform="translate(176.21 624.8) rotate(180)"
      />
    </g>
    <path
      class="cls-902"
      d="M65.28,270.21h0c-1.37,.32-2.21,1.68-1.89,3.05l11.92,51.02c.32,1.37,1.68,2.21,3.05,1.89h0c1.37-.32,2.21-1.68,1.89-3.05l-11.92-51.02c-.32-1.37-1.68-2.21-3.05-1.89Z"
    />
    <g>
      <path
        class="cls-471"
        d="M49.1,220.39s5.43-5.97,11.79-5.97v5.84l-11.79,4.34v-4.21Z"
      />
      <path
        class="cls-471"
        d="M72.68,220.39s-5.43-5.97-11.79-5.97v5.84l11.79,4.34v-4.21Z"
      />
      <path
        class="cls-472"
        d="M72.68,220.39s-5.43-5.97-11.79-5.97v5.84l11.79,4.34v-4.21Z"
      />
    </g>
    <path
      class="cls-611"
      d="M51.63,259.93h0v29.15h0c-3.19,0-5.77-2.59-5.77-5.77v-17.6c0-3.19,2.59-5.77,5.77-5.77Z"
    />
    <circle class="cls-933" cx="77.23" cy="323.81" r="6.95" />
    <g>
      <path
        class="cls-105"
        d="M80.11,325.78c1.5-2.25,.09-5.23-2.65-5.46-1.22-.11-2.43,.49-3.11,1.51-1.5,2.25-.09,5.23,2.65,5.46,1.22,.1,2.43-.49,3.11-1.51Z"
      />
      <path
        class="cls-717"
        d="M79.91,325.61c1.33-2.04,.11-4.7-2.3-5.02-1.2-.16-2.41,.4-3.07,1.41-1.33,2.04-.11,4.7,2.3,5.02,1.2,.16,2.41-.4,3.07-1.41Z"
      />
      <path
        class="cls-707"
        d="M79.32,325.39c1.26-1.73,.14-4.1-2.03-4.2-.84-.04-1.65,.36-2.14,1.04-1.26,1.73-.13,4.1,2.03,4.2,.84,.04,1.65-.36,2.14-1.04Z"
      />
      <path
        class="cls-336"
        d="M79.2,325.27c1.13-1.58,.15-3.73-1.79-3.91-.83-.08-1.67,.31-2.16,.99-1.13,1.58-.15,3.73,1.79,3.91,.83,.08,1.67-.31,2.16-.99Z"
      />
      <path
        class="cls-22"
        d="M78.92,325.06c.97-1.36,.13-3.2-1.54-3.36-.71-.07-1.43,.26-1.85,.85-.97,1.36-.13,3.2,1.54,3.36,.71,.07,1.43-.26,1.85-.85Z"
      />
      <path
        class="cls-717"
        d="M76.19,324.42l-.14-.85c-.02-.13,.03-.27,.13-.35l.67-.55c.1-.09,.25-.11,.37-.06l.81,.3c.13,.05,.22,.16,.24,.29l.14,.85c.02,.13-.03,.27-.13,.35l-.67,.55c-.1,.09-.25,.11-.37,.06l-.81-.3c-.13-.05-.22-.16-.24-.29Z"
      />
      <path
        class="cls-254"
        d="M76.3,323.58l.88-.73s.09-.04,.14-.02l.95,.35-.03-.21-1.14-.42s-.1,0-.14,.02l-.88,.73s-.06,.08-.05,.13l.2,1.2,.2,.07-.17-1s.01-.1,.05-.13Z"
      />
    </g>
    <ellipse class="cls-159" cx="60.94" cy="218.37" rx="8.48" ry="4.58" />
  </g>
</template>

<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
